import { lazy } from "react";
import { useLanguage } from "./index";

const contentMap = {
  sv: {
    welcome: lazy(() => import("./content/sv/WelcomeContent")),
    history: lazy(() => import("./content/sv/HistoryContent")),
    visit: lazy(() => import("./content/sv/VisitContent")),
    aktuellt: lazy(() => import("./content/sv/AktuelltContent")),
    open: lazy(() => import("./content/sv/OpenContent")),
    sponsorer: lazy(() => import("./content/sv/SponsorerContent")),
  },
  en: {
    welcome: lazy(() => import("./content/en/WelcomeContent")),
    history: lazy(() => import("./content/en/HistoryContent")),
    visit: lazy(() => import("./content/en/VisitContent")),
    aktuellt: lazy(() => import("./content/en/AktuelltContent")),
    open: lazy(() => import("./content/en/OpenContent")),
    sponsorer: lazy(() => import("./content/en/SponsorerContent")),
  },
  de: {
    welcome: lazy(() => import("./content/de/WelcomeContent")),
    history: lazy(() => import("./content/de/HistoryContent")),
    visit: lazy(() => import("./content/de/VisitContent")),
    aktuellt: lazy(() => import("./content/de/AktuelltContent")),
    open: lazy(() => import("./content/de/OpenContent")),
    sponsorer: lazy(() => import("./content/de/SponsorerContent")),
  },
};

export function useContent(pageKey) {
  const { lang } = useLanguage();
  return contentMap[lang]?.[pageKey] || contentMap.sv[pageKey];
}
